import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// The design system is imported first on purpose. Bundled CSS lands in module
// evaluation order, and styles/landing.css (pulled in transitively by App)
// *extends* these tokens and components - so it has to come after them, or a
// same-specificity landing rule silently loses to the base rule it meant to
// override. That is not hypothetical: it hid the mobile navigation once.
import "@/styles/global.css";
import { App } from "@/App";
import { SessionProvider } from "@/state/session";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
